import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Header from '../Component/Header';
import ProjectHeader from '../Component/ProjectHeader';

function DoorsStandardQuoteDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const quotationId = location?.state?.quotationId;
  const type = location?.state?.type;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [itemRowIndex, setItemRowIndex] = useState(null);
  const [selectedItem , setSelectedItem] = useState(null);
  const [designs , setDesigns] = useState([]);
  const [showDesignsPopup, setShowDesignsPopup] = useState(false);
  const [showHardwarePopup, setShowHardwarePopup] = useState(false);
  const [hardware, setHardware] = useState([]);
  const [selectedHardware, setSelectedHardware] = useState({});
  
  const [showAddonPopup, setShowAddonPopup] = useState(false);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [selectedAddonVendor, setSelectedAddonVendor] = useState(null);
  const [selectedAddonSubcategory, setSelectedAddonSubcategory] = useState(null);
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [applyingDesign, setApplyingDesign] = useState(false);
  const [designApplied, setDesignApplied] = useState(false);
 
  const [applyingHardware, setApplyingHardware] = useState(false);
const [hardwareAdded, setHardwareAdded] = useState(false);
const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (quotationId) {
      fetchQuotationDetails();
    }
  }, [quotationId]);

  const fetchQuotationDetails = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quote?quotation_id=${quotationId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );

      const result = await response.json();
      console.log(result?.data?.quotation);
      setData(result?.data?.quotation || {});
    } catch (err) {
      console.error('Error fetching quotation details:', err);
    } finally {
      setLoading(false);
    }
  };
  
  // Modify the handleMapAddonVendors function to make addons clickable
  const handleMapAddonVendors = (item) => {
    // Check if item has addons
    if (!item.product_addons || item.product_addons.length === 0) {
      return null;
    }
  
    return (
      <div className="mb-3">
        <div className="flex flex-wrap gap-2">
          {item.product_addons.filter(p=>p.product_addon_type !== 'hardware').map((addon, index) => {
            // Find the vendor for this addon
            const addonVendor = data?.vendors?.find(
              (v) => v._id === addon.vendor_id || v._id === addon.vendor?._id
            );
  
            // Find the subcategory for this addon
            const addonSubcategory = data?.subcategories?.find(
              (s) =>
                s._id === addon.item_sub_category_id ||
                s._id === addon.item_subcategory?._id
            );
  
            return (
              <div 
                key={index} 
                className="flex flex-col items-center cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => handleAddonClick(addon, addonVendor, addonSubcategory, item)}
              >
                {addonVendor?.image && (
                  <div className="relative border border-gray-300 rounded-md py-1 px-2">
                    <img
                      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + addonVendor.image}
                      alt={addonVendor.name || "Vendor"}
                      className="w-10 h-8 object-contain"
                    />
                  </div>
                )}
                <span
                  className="text-[10px] text-gray-800 mt-1 max-w-[60px] text-center truncate"
                 /*  title={
                    addonSubcategory?.product_sub_category_name ||
                    addonSubcategory?.name ||
                    "Addon"
                  } */
                >
                  {addonSubcategory?.product_sub_category_name ||
                    addonSubcategory?.name ||
                    "Addon"}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  
  // Add this function to handle addon clicks
  const handleAddonClick = (addon, vendor, subcategory, parentItem) => {
    setSelectedAddon(addon);
    setSelectedAddonVendor(vendor);
    setSelectedAddonSubcategory(subcategory);
    setShowAddonPopup(true);
  };

  const renderAddonDetailsPopup = () => {
    if (!showAddonPopup || !selectedAddon) return null;
    
    return (
      <>
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
          onClick={() => setShowAddonPopup(false)}
        ></div>
        
        {/* Popup - positioned at bottom with slide-up animation */}
        <div className="fixed inset-x-0 bottom-0 bg-white rounded-t-xl shadow-lg z-50 max-h-[80vh] overflow-y-auto transform transition-transform duration-300 ease-out">
          {/* Header with close button */}
          <div className="sticky top-0 bg-white px-4 py-3 border-b border-gray-200 z-10">
            <div className="flex justify-between items-center">
              <div className="flex flex-col">
                <h2 className="text-xl font-bold text-gray-800">Custamisation Details</h2>
                <h3 className="text-sm text-gray-600">
                  {selectedAddonSubcategory?.product_sub_category_name || selectedAddonSubcategory?.name || "Addon"}
                </h3>
              </div>
              <button
                onClick={() => setShowAddonPopup(false)}
                className="text-gray-500 hover:text-gray-700 p-1.5"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          
          {/* Addon content */}
          <div className="p-4">
            {/* Vendor information */}
            <div className="mb-4">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium text-gray-500">Vendor</h4>
                <span className="text-xs text-[#3C5DB1]">Premium Partner</span>
              </div>
              <div className="flex items-center bg-gray-50 p-3 rounded-lg border border-gray-200">
                {selectedAddonVendor?.image && (
                  <div className="mr-3 border border-gray-200 rounded-md p-1 bg-white">
                    <img
                      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedAddonVendor.image}
                      alt={selectedAddonVendor.name || "Vendor"}
                      className="w-16 h-12 object-contain"
                    />
                  </div>
                )}
                <div>
                  <h5 className="font-medium text-gray-800">{selectedAddonVendor?.name || "Unknown Vendor"}</h5>
                  {selectedAddonVendor?.description ? (
                    <p className="text-sm text-gray-600 mt-1 line-clamp-2">{selectedAddonVendor.description}</p>
                  ) : (
                    <p className="text-sm text-gray-600 mt-1">Quality Door Custamisation Partner</p>
                  )}
                </div>
              </div>
            </div>
            
            {/* Addon details */}
            <div className="mb-4">
              <h4 className="text-sm font-medium text-gray-500 mb-2">Custamisation Details</h4>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <p className="text-xs text-gray-500">Name</p>
                    <p className="text-sm font-medium">
                      {selectedAddon?.item_name || selectedAddon?.name || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Category</p>
                    <p className="text-sm font-medium">
                      {selectedAddonSubcategory?.product_sub_category_name || selectedAddonSubcategory?.name || "N/A"}
                    </p>
                  </div>
                 {/*  <div>
                    <p className="text-xs text-gray-500">Quantity</p>
                    <p className="text-sm font-medium">{selectedAddon?.quantity || 1}</p>
                  </div> */}
                 {/*  <div>
                    <p className="text-xs text-gray-500">Price</p>
                    <p className="text-sm font-medium text-[#14A311]">
                      ₹{formatCurrency(selectedAddon?.selling_price || selectedAddon?.price || 0)}
                    </p>
                  </div> */}
                </div>
                
                {selectedAddon?.description && (
                  <div className="mt-3">
                    <p className="text-xs text-gray-500">Description</p>
                    <p className="text-sm mt-1">{selectedAddon.description}</p>
                  </div>
                )}
                
                {/* Specifications if available */}
                {selectedAddon?.specifications && Object.keys(selectedAddon.specifications).length > 0 && (
                  <div className="mt-3">
                    <p className="text-xs text-gray-500 mb-1">Specifications</p>
                    <div className="space-y-1">
                      {Object.entries(selectedAddon.specifications).map(([key, value], index) => (
                        <div key={index} className="flex justify-between text-sm">
                          <span className="text-gray-600">{key}:</span>
                          <span className="font-medium">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Material & Finish section */}
            <div className="mb-4">
              <h4 className="text-sm font-medium text-gray-500 mb-2">Material & Finish</h4>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <p className="text-xs text-gray-500">Material</p>
                    <p className="text-sm font-medium">
                      {selectedAddon?.material || "Premium Meterial"}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Finish</p>
                    <p className="text-sm font-medium">
                      {selectedAddon?.finish || "Brushed Nickel"}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Warranty</p>
                    <p className="text-sm font-medium">{selectedAddon?.warranty || "1 Year"}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Installation</p>
                    <p className="text-sm font-medium">{selectedAddon?.installation || "Included"}</p>
                  </div>
                </div>
              </div>
            </div>
            
            
            {/* Customization information box */}
            <div className="bg-[#FFF8E6] border border-[#FFE7A3] rounded-lg p-3 mb-4">
              <div className="flex items-start">
                <div className="text-[#F5A623] mr-2 mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h5 className="text-sm font-medium text-[#8B6E00] mb-1">Want to customize this addon?</h5>
                  <p className="text-xs text-[#8B6E00]">
                    To change the vendor or customize this addon, please close this popup and click the 
                    <span className="font-bold mx-1">Customize</span> 
                    button at the bottom of the screen.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Quality assurance section */}
            <div className="mb-4">
              <h4 className="text-sm font-medium text-gray-500 mb-2">Quality Assurance</h4>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                <div className="flex items-center mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-sm">Quality tested by Brickbucket</p>
                </div>
                <div className="flex items-center mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-sm">Genuine product guarantee</p>
                </div>
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <p className="text-sm">Professional installation</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center mb-2">
    <button
      onClick={() => setShowAddonPopup(false)}
      className="border border-[#F30F0F] bg-white text-[#F30F0F] font-medium py-2.5 px-6 rounded-lg text-sm flex items-center justify-between"
    >
      <span>Close</span>
    </button>
  </div>
          
          {/* Action button */}
         {/*  <div className="sticky bottom-0 bg-white py-2 border-t border-gray-200 shadow-md">
 
</div> */}

        </div>
      </>
    );
  };
  
  const  handleOpenDesignPopUp = (item, index) =>{
  //  console.log(item, index)
   setItemRowIndex(index);
   setShowDesignsPopup(true)
   setSelectedItem(item);
   handleGetDoorDesigns(item.item_group_id)
   //console.log(item.applied_areas)

   // Get selected design information with proper error handling
const getSelectedDesign = (item) => {
  try {
    // Check if item and required properties exist
    if (!item || !item.applied_areas || !Array.isArray(item.applied_areas) || item.applied_areas.length === 0) {
      return null;
    }
    
    const appliedArea = item.applied_areas[0];
    
    // Check if selected_design exists and is an array or object
    if (!appliedArea.selected_design) {
      return null;
    }
    
    // If selected_design is an array, map over it
    if (Array.isArray(appliedArea.selected_design)) {
      if (appliedArea.selected_design.length === 0) {
        return null;
      }
      
      // Return the first design in the array (assuming we only need one)
      const design = appliedArea.selected_design[0];
      return {
        item_id: design.design_id,
        item_name: design.design_name,
        item_image: design.design_image,
        item_group_id: item.item_group_id,
      };
    } 
    // If selected_design is an object, use it directly
    else if (typeof appliedArea.selected_design === 'object') {
      const design = appliedArea.selected_design;
      return {
        item_id: design.design_id,
        item_name: design.design_name,
        item_image: design.design_image,
        item_group_id: item.item_group_id,
      };
    }
    
    return null;
  } catch (error) {
    console.error("Error getting selected design:", error);
    return null;
  }
};

// Usage example:
const selectedDesign = getSelectedDesign(item);

   setSelectedDesign(selectedDesign)
  }



    const handleOpenHardwarePopUp = (item, index, hardwareItems) => {
     // console.log('handleOpenHardwarePopUp called with item:', hardwareItems);
      setItemRowIndex(index);
      setShowHardwarePopup(true);
      setSelectedItem(item);
      
      // Convert hardware items to the format expected by the hardware popup
      if (hardwareItems && Array.isArray(hardwareItems) && hardwareItems.length > 0) {
        const hardwareMap = {};
        
        hardwareItems.forEach(hardware => {
          // Ensure we have valid item_id and item_group_id
          if (!hardware.item_id || !hardware.item_group_id) {
            console.warn('Hardware item missing required IDs:', hardware);
            return; // Skip this item
          }
          
          // Create a unique key for each hardware item
          const key = `${hardware.item_group_id}-${hardware.item_id}`;
          
          // Find the group information
          const group = {
            product_group_id: hardware.item_group_id,
            product_group_name: hardware.item_group_name || "Hardware Group"
          };
          
          // Format the product information to match what the popup expects
          const product = {
            _id: hardware.item_id,
            product_name: hardware.item_name,
            product_image: hardware.item_image,
            selling_price: hardware.selling_price || 0,
            cost_price: hardware.cost_price || 0,
            tax_rate: hardware.tax_rate || 0,
            UOM_id: hardware.UOM || "pcs"
          };
          
          // Add to the map with the proper structure that matches handleSelectHardware
          hardwareMap[key] = {
            group,
            product,
            quantity: parseInt(hardware.quantity) || 1
          };
        });
        
       // console.log('Hardware Map:', hardwareMap);
        // Set the selected hardware with the properly formatted data
        setSelectedHardware(hardwareMap);
      } else {
        // Reset selected hardware if none is provided
        setSelectedHardware({});
      }
      
      // Fetch hardware options - ensure we're passing the correct product category ID
      if (data && data.product_category_id) {
        handleGetDoorHardware(data.product_category_id);
      } else {
        console.error('Product category ID not available for fetching hardware options');
      }
    };
    
  const handleGetDoorDesigns = async (id) => {
   
    try {
      const token = sessionStorage.getItem('token');
      
      // Make the API call
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-products-by-product-group?product_group_id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const responseData = await response.json();
      
      if (responseData.success) {
        setDesigns(responseData.data); // Set the fetched data in the state
        setShowDesignsPopup(true); // Show the popup after data is loaded
       // console.log(responseData);
      } else {
        console.error('Error fetching tile designs:', responseData.message);
        // Optionally show an error message to the user
      }
    } catch (error) {
      console.error('Failed to fetch tile designs:', error);
      // Handle error appropriately
    }
  };

  const handleGetDoorHardware = async (productCategory) => {

  try{
    const token = sessionStorage.getItem('token');
      
      // Make the API call
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-door-hardware?product_category_id=${productCategory._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const responseData = await response.json();
      
      if (responseData.success) {
        console.log(responseData.data);
        setHardware(responseData.data); // Set the fetched data in the state
        setShowHardwarePopup(true); // Show the popup after data is loaded
        //console.log(responseData);
      } else {
        console.error('Error fetching tile designs:', responseData.message);
        // Optionally show an error message to the user
      }

  }catch(error){
    console.log(error)
  }
}

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(amount);
};


const handleDesignSelection = (design) => {
  setSelectedDesign(design);
};


const handleApplyDesign = async () => {
  if (!selectedDesign || !selectedItem) return;
  
   setApplyingDesign(true);

  try {
    
     // Get token from session storage
    const token = sessionStorage.getItem('token');
    
    // Prepare the request body
    const requestBody = {
      quotationId: quotationId,
      item_id: selectedItem.item_id || selectedItem._id,
      design_id: selectedDesign.item_id || selectedDesign._id,
      applied_areas: selectedItem.applied_areas.map(area => area.area_name) 
    };
    
    // Make API call to update the design
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-selected-designs`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(requestBody)
    });
    
    const result = await response.json(); 
    
    if (result.success) {
      // If successful, set design applied to true
      setDesignApplied(true);
      
      // Refresh quotation details to show updated design
      fetchQuotationDetails();
    } else {
      // Handle error
      console.error('Error applying design:', result.message);
      alert('Failed to apply design. Please try again.');
    } 
      setTimeout(() => {
        setDesignApplied(true);
      }, 1000);
       
      // Refresh quotation details to show updated design
      fetchQuotationDetails();
  } catch (error) {
    console.error('Error applying design:', error);
    alert('An error occurred. Please try again.');
  } finally {
      
    setApplyingDesign(false);   
  }
};


const closeDesignPopup = () => {
  setShowDesignsPopup(false);
  setItemRowIndex(null);
  setSelectedItem(null);
  setSelectedDesign(null);
  setDesignApplied(false);
};


 const renderDesignSelectionPopup = () => {
  if (!showDesignsPopup || !selectedItem) return null;
  
  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
        onClick={closeDesignPopup}
      ></div>
      
      {/* Popup - positioned at bottom with slide-up animation */}
      <div className="fixed inset-x-0 bottom-0 bg-white rounded-t-xl shadow-lg z-50 max-h-[85vh] overflow-y-auto transform transition-transform duration-300 ease-out">
        {/* Header with close button */}
        <div className="sticky top-0 bg-white px-4 py-3 border-b border-gray-200 z-10">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-gradient-to-br from-[#F30F0F] to-[#C20C0C] rounded-lg flex items-center justify-center mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="3" y="2" width="18" height="20" rx="1" />
                  <path d="M6 2v20" />
                  <path d="M15 12h2" />
                  <path d="M10 7v2" />
                  <path d="M10 15v2" />
                </svg>
              </div>
              <div className="flex flex-col">
                <h2 className="text-lg font-bold text-gray-900">Door Designs</h2>
                <h3 className="text-xs text-gray-600">
                  Choose design for {selectedItem?.application_areas?.area_name || 'this area'}
                </h3>
              </div>
            </div>
            <button
              onClick={closeDesignPopup}
              className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        {/* Design grid - Only show if not in applied or applying state */}
        {!applyingDesign && !designApplied && (
          <div className="p-4 bg-gray-50">
            {designs.length > 0 ? (
              <>
                {/* Information banner */}
                <div className="mb-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-3">
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-xs text-blue-800 font-medium mb-1">Select Your Preferred Design</p>
                      <p className="text-[10px] text-blue-700">
                        Tap on any design below and click "Apply Design" to update your door appearance.
                      </p>
                    </div>
                  </div>
                </div>
                
                {/* Design grid with improved cards */}
                <div className="grid grid-cols-2 gap-3">
                  {designs.map((design, index) => (
                    <div
                      key={index}
                      className={`bg-white border-2 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 shadow-sm ${
                        selectedDesign && selectedDesign.item_id === design.item_id
                          ? 'border-[#F30F0F] shadow-lg transform scale-[1.02]'
                          : 'border-gray-200 hover:border-gray-300 hover:shadow-md'
                      }`}
                      onClick={() => handleDesignSelection(design)}
                    >
                      {/* Design image with overlay for selected state */}
                      <div className="relative h-32 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                        <img
                          src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + design.item_image}
                          alt={design.item_name}
                          className="w-full h-full object-contain p-2"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/200x128?text=Door+Design";
                          }}
                        />
                        
                        {/* Selected overlay */}
                        {selectedDesign && selectedDesign.item_id === design.item_id && (
                          <div className="absolute inset-0 bg-[#F30F0F] bg-opacity-10 flex items-center justify-center">
                            <div className="bg-[#F30F0F] rounded-full p-2">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                              </svg>
                            </div>
                          </div>
                        )}
                      </div>
                      
                      {/* Design info */}
                      <div className="p-3">
                        <h5 
                          className="text-sm font-semibold text-gray-800 mb-1 leading-tight h-8 overflow-hidden" 
                          title={design.item_name}
                          style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            wordBreak: 'break-word'
                          }}
                        >
                          {design.item_name}
                        </h5>
                        
                        {/* Selection indicator */}
                        {selectedDesign && selectedDesign.item_id === design.item_id ? (
                          <div className="flex items-center text-[#F30F0F]">
                            <div className="w-3 h-3 bg-[#F30F0F] rounded-full flex items-center justify-center mr-1.5">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-2 w-2 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
                              </svg>
                            </div>
                            <span className="text-xs font-medium">Selected</span>
                          </div>
                        ) : (
                          <div className="flex items-center text-gray-400">
                            <div className="w-3 h-3 border border-gray-300 rounded-full mr-1.5"></div>
                            <span className="text-xs">Tap to select</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="flex flex-col justify-center items-center h-48 bg-white rounded-xl border border-gray-200">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <p className="text-gray-500 font-medium text-sm mb-1">No designs available</p>
                <p className="text-gray-400 text-xs text-center">Check back later for more design options</p>
              </div>
            )}
          </div>
        )}
        
        {/* Loading state */}
        {applyingDesign && (
          <div className="p-8 flex flex-col items-center justify-center bg-gray-50">
            <div className="relative">
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200"></div>
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#F30F0F] border-t-transparent absolute top-0"></div>
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2 mt-4">Applying Design</h3>
            <p className="text-sm text-gray-600 text-center max-w-xs">
              Please wait while we apply the selected design to your door.
            </p>
            <div className="flex space-x-1 mt-3">
              <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
              <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
            </div>
          </div>
        )}
        
       {/* Success state */}
{designApplied && (
  <div className="p-8 flex flex-col items-center justify-center bg-gradient-to-br from-red-50 to-pink-50">
    <div className="relative">
      <div className="bg-gradient-to-br from-[#F30F0F] to-[#C20C0C] rounded-full h-20 w-20 flex items-center justify-center mb-4 shadow-lg">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div className="absolute -top-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-[#F30F0F]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
    <h3 className="text-xl font-bold text-gray-800 mb-2">Design Applied!</h3>
    <p className="text-sm text-gray-600 text-center mb-4 max-w-xs">
      Your selected design has been successfully applied to the door.
    </p>
    <div className="bg-white rounded-lg p-3 border border-red-200 shadow-sm">
      <p className="text-xs text-[#C20C0C] font-medium">✓ Design updated in your quotation</p>
    </div>
  </div>
)}

{/* Action buttons */}
<div className="sticky bottom-0 bg-white p-4 border-t border-gray-200 shadow-lg">
  {!applyingDesign && !designApplied ? (
    <div className="flex space-x-3">
      <button
        onClick={closeDesignPopup}
        className="flex-1 border border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors"
      >
        Cancel
      </button>
      <button
        onClick={handleApplyDesign}
        disabled={!selectedDesign}
        className={`flex-2 py-3 px-6 rounded-lg font-semibold transition-all duration-200 ${
          selectedDesign
            ? 'bg-gradient-to-r from-[#F30F0F] to-[#C20C0C] text-white hover:from-[#E00E0E] hover:to-[#B00B0B] shadow-lg'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
      >
        {selectedDesign ? 'Apply Design' : 'Select a Design'}
      </button>
    </div>
  ) : designApplied ? (
    <button
      onClick={closeDesignPopup}
      className="w-full bg-gradient-to-r from-[#F30F0F] to-[#C20C0C] text-white font-semibold py-3 px-4 rounded-lg hover:from-[#E00E0E] hover:to-[#B00B0B] transition-all duration-200 shadow-lg"
    >
      Continue
    </button>
  ) : null}
</div>

      </div>
    </>
  );
};



const handlePrepareQuotationData = async(hardwareItems) => {
  try {
    // Deep clone to avoid mutation issues with proper error handling
    let quotationData;
    try {
      quotationData = JSON.parse(JSON.stringify(data));
    } catch (parseError) {
      throw new Error(`Failed to clone quotation data: ${parseError.message}`);
    }
    
    // Validate itemRowIndex exists and is within bounds with detailed error messages
    if (itemRowIndex === null) {
      throw new Error("No item selected - itemRowIndex is null");
    }
    
    if (!quotationData.items) {
      throw new Error("Quotation has no items array");
    }
    
    if (!Array.isArray(quotationData.items)) {
      throw new Error("Quotation items is not an array");
    }
    
    if (itemRowIndex < 0) {
      throw new Error(`Invalid itemRowIndex: ${itemRowIndex} (negative value)`);
    }
    
    if (itemRowIndex >= quotationData.items.length) {
      throw new Error(`Invalid itemRowIndex: ${itemRowIndex} (out of bounds, max: ${quotationData.items.length - 1})`);
    }
    
    // Ensure product_addons exists or initialize it
    const currentItem = quotationData.items[itemRowIndex];
    if (!currentItem) {
      throw new Error(`Item at index ${itemRowIndex} is undefined or null`);
    }
    
    if (!currentItem.product_addons) {
      currentItem.product_addons = [];
    } else if (!Array.isArray(currentItem.product_addons)) {
      currentItem.product_addons = []; // Reset if not an array
      console.warn(`Item's product_addons was not an array - reset to empty array`);
    }
    
    // Filter out existing hardware items if they exist with validation
    let addons = [];
    try {
      addons = Array.isArray(currentItem.product_addons) 
        ? currentItem.product_addons.filter(addon => 
            addon && typeof addon === 'object' && addon.product_addon_type !== 'hardware'
          )
        : [];
    } catch (filterError) {
      console.error("Error filtering addons:", filterError);
      addons = []; // Fallback to empty array on error
    }
    
    // Validate hardware items with detailed validation
    let validHardwareItems = [];
    if (!hardwareItems) {
      console.warn("No hardware items provided");
    } else if (!Array.isArray(hardwareItems)) {
      console.error("Hardware items is not an array");
    } else {
      validHardwareItems = hardwareItems.filter(item => {
        if (!item) {
          console.warn("Skipping null/undefined hardware item");
          return false;
        }
        if (typeof item !== 'object') {
          console.warn(`Skipping non-object hardware item: ${typeof item}`);
          return false;
        }
        if (!item.item_id) {
          console.warn("Hardware item missing item_id");
          return false;
        }
        return true;
      });
    }
    
    // Combine addons with proper validation
    try {
      currentItem.product_addons = [...addons, ...validHardwareItems];
    } catch (combineError) {
      console.error("Error combining addons:", combineError);
      currentItem.product_addons = [...addons]; // Fallback to just keeping existing non-hardware addons
    }
    
    // Calculate updated quotation data with error handling
    let updatedQuotationData;
    try {
      updatedQuotationData = await handleCalculateQuotationData(quotationData);
    } catch (calcError) {
      console.error("Error calculating quotation data:", calcError);
      throw new Error(`Failed to calculate quotation data: ${calcError.message}`);
    }
    
    console.log("Updated Quotation Data:", updatedQuotationData);
    return updatedQuotationData;
  } catch (error) {
    console.error("Error preparing quotation data:", error);
    throw new Error(`Failed to prepare quotation data: ${error.message}`);
  }
};

const handleCalculateQuotationData = (quotationData) => {
  // Ensure quotationData is an object with detailed validation
  if (!quotationData) {
    throw new Error("Quotation data is null or undefined");
  }
  
  if (typeof quotationData !== 'object') {
    throw new Error(`Quotation data is not an object, got ${typeof quotationData}`);
  }
  
  if (Array.isArray(quotationData)) {
    throw new Error("Quotation data is an array, expected an object");
  }
  
  // Initialize totals with safe defaults
  let subtotal = 0;
  let taxAmount = 0;
  let total = 0;
  
  // Process each item in the quotation with error handling
  if (!quotationData.items) {
    console.warn("Quotation has no items array");
  } else if (!Array.isArray(quotationData.items)) {
    console.error("Quotation items is not an array");
  } else {
    // Process each item safely
    quotationData.items.forEach((item, index) => {
      if (!item) {
        console.warn(`Item at index ${index} is null or undefined - skipping`);
        return;
      }
      
      // Calculate base item price with safe number conversion
      const itemQuantity = parseFloat(item.quantity) || 1;
      if (isNaN(itemQuantity)) {
        console.warn(`Invalid quantity for item at index ${index}: ${item.quantity}`);
      }
      
      const itemPrice = parseFloat(item.selling_price) || 0;
      if (isNaN(itemPrice)) {
        console.warn(`Invalid selling price for item at index ${index}: ${item.selling_price}`);
      }
      
      const itemSubtotal = itemQuantity * itemPrice;
      
      // Initialize item totals
      let itemTaxAmount = 0;
      let itemTotal = itemSubtotal;
      
      // Process hardware addons if they exist with validation
      if (item.product_addons) {
        if (!Array.isArray(item.product_addons)) {
          console.error(`Item at index ${index} has product_addons that is not an array`);
        } else {
          item.product_addons.forEach((addon, addonIndex) => {
            if (!addon) {
              console.warn(`Addon at index ${addonIndex} for item ${index} is null or undefined - skipping`);
              return;
            }
            
            if (addon.product_addon_type === 'hardware') {
              // Calculate addon price with safe number conversion
              const addonQuantity = parseFloat(addon.quantity) || 1;
              if (isNaN(addonQuantity)) {
                console.warn(`Invalid quantity for addon at index ${addonIndex}: ${addon.quantity}`);
              }
              
              const addonPrice = parseFloat(addon.selling_price) || 0;
              if (isNaN(addonPrice)) {
                console.warn(`Invalid selling price for addon at index ${addonIndex}: ${addon.selling_price}`);
              }
              
              const addonSubtotal = addonQuantity * addonPrice;
              
              // Calculate addon tax with safe number conversion
              const addonTaxRate = parseFloat(addon.tax_rate) || 0;
              if (isNaN(addonTaxRate)) {
                console.warn(`Invalid tax rate for addon at index ${addonIndex}: ${addon.tax_rate}`);
              }
              
              const addonTaxAmount = (addonSubtotal * addonTaxRate) / 100;
              
              // Update addon totals
              addon.total_price = addonSubtotal;
              addon.total_tax = addonTaxAmount;
              
              // Add to item totals
              itemTotal += addonSubtotal;
              itemTaxAmount += addonTaxAmount;
            }
          });
        }
      }
      
      // Calculate item tax if not already calculated from addons
      const itemTaxRate = parseFloat(item.tax_rate) || 0;
      if (isNaN(itemTaxRate)) {
        console.warn(`Invalid tax rate for item at index ${index}: ${item.tax_rate}`);
      }
      
      if (itemTaxAmount === 0 && itemTaxRate > 0) {
        itemTaxAmount = (itemSubtotal * itemTaxRate) / 100;
      }
      
      // Update item totals with rounding to avoid floating point issues
      item.total = parseFloat(itemTotal.toFixed(2));
      item.total_tax_amount = parseFloat(itemTaxAmount.toFixed(2));
      
      // Add to quotation totals
      subtotal += itemTotal;
      taxAmount += itemTaxAmount;
    });
  }
  
  // Calculate final total with rounding to avoid floating point issues
  total = subtotal + taxAmount;
  
  // Update quotation totals
  quotationData.subtotal = parseFloat(subtotal.toFixed(2));
  quotationData.tax_amount = parseFloat(taxAmount.toFixed(2));
  quotationData.total = parseFloat(total.toFixed(2));
  
  return quotationData;
};


const HandleSaveHardwareToItem = async (hardwareItems) => {
  // Reset states at the beginning
  setErrorMessage(null);
  
  // Validate input with detailed checks
  if (!hardwareItems) {
    setErrorMessage("Hardware items are undefined or null");
    return false;
  }
  
  if (!Array.isArray(hardwareItems)) {
    setErrorMessage("Hardware items must be an array");
    return false;
  }
  
  if (hardwareItems.length === 0) {
    setErrorMessage("No hardware items to save");
    return false;
  }
  
  // Validate quotationId
  if (!quotationId) {
    setErrorMessage("Quotation ID is missing");
    return false;
  }
  
  setApplyingHardware(true);
  
  try {
    // Get token with validation
    const token = sessionStorage.getItem('token');
    if (!token) {
      throw new Error("Authentication token not found");
    }
    
    // Prepare data with error handling
    let preparedData;
    try {
      // Since handlePrepareQuotationData is async, we need to await it
      preparedData = await handlePrepareQuotationData(hardwareItems);
      
      if (!preparedData) {
        throw new Error("Prepared data is empty or null");
      }
    } catch (prepError) {
      throw new Error(`Data preparation failed: ${prepError.message}`);
    }
    
    // API endpoint validation
    const apiEndpoint = process.env.REACT_APP_FORE_BRICKBUCKET;
    if (!apiEndpoint) {
      throw new Error("API endpoint configuration is missing");
    }
    
    // Make API call with timeout and retry logic
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout
    
    try {
      console.log('Sending data to API:', {
        endpoint: `${apiEndpoint}customer/quotations/update-quotation-data?quotation_id=${quotationId}`,
        method: 'PUT',
        dataSize: JSON.stringify(preparedData).length
      });
      
      const response = await fetch(`${apiEndpoint}customer/quotations/update-quotation-data?quotation_id=${quotationId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(preparedData),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      // Check for HTTP errors with better error handling
      if (!response.ok) {
        let errorMessage;
        try {
          // Try to parse error as JSON first
          const errorJson = await response.json();
          errorMessage = errorJson.message || errorJson.error || JSON.stringify(errorJson);
        } catch (jsonError) {
          // If not JSON, get as text
          try {
            errorMessage = await response.text();
          } catch (textError) {
            errorMessage = `HTTP Error ${response.status}`;
          }
        }
        
        throw new Error(`Server responded with ${response.status}: ${errorMessage}`);
      }
      
      // Parse response with error handling
      let result;
      try {
        result = await response.json();
      } catch (jsonError) {
        throw new Error(`Failed to parse server response: ${jsonError.message}`);
      }
      
      // Validate response structure
      if (!result) {
        throw new Error("Empty response from server");
      }
      
      if (result.success === false) {
        throw new Error(result.message || "Server indicated operation failed");
      }
      
      // Success path
      console.log('Hardware saved successfully:', result);
      setHardwareAdded(true);
      
      // Refresh quotation details
      try {
        await fetchQuotationDetails();
      } catch (fetchError) {
        console.warn('Failed to refresh quotation details:', fetchError);
        // Continue with success even if refresh fails
      }
      
      return true;
    } catch (fetchError) {
      if (fetchError.name === 'AbortError') {
        throw new Error("Request timed out. Please try again.");
      }
      
      // Add more context to network errors
      if (fetchError instanceof TypeError && fetchError.message.includes('NetworkError')) {
        throw new Error(`Network error: Please check your internet connection. Details: ${fetchError.message}`);
      }
      
      throw fetchError;
    } finally {
      clearTimeout(timeoutId);
    }
  } catch (error) {
    console.error('Error saving hardware:', error);
    
    // Set a user-friendly error message
    const userMessage = error.message || "An unexpected error occurred";
    setErrorMessage(userMessage.includes('Internal Server Error') 
      ? 'Server error. Please try again later.' 
      : userMessage);
    
    return false;
  } finally {
    setApplyingHardware(false);
  }
};

  
const renderHardwareSelectionPopup = () => {
  if (!showHardwarePopup) return null;
  
  // Handle quantity change
  const handleQuantityChange = (groupId, productId, newQuantity) => {
    setSelectedHardware(prev => ({
      ...prev,
      [`${groupId}-${productId}`]: {
        ...prev[`${groupId}-${productId}`],
        quantity: Math.max(1, newQuantity)
      }
    }));
  };
  
  // Handle hardware selection
  const handleSelectHardware = (group, product) => {
    const key = `${group.product_group_id}-${product._id}`;
    
    setSelectedHardware(prev => {
      // If already selected, update quantity or remove if quantity is 0
      if (prev[key]) {
        if (prev[key].quantity <= 0) {
          const newSelected = { ...prev };
          delete newSelected[key];
          return newSelected;
        }
        return { ...prev };
      }
      
      // If not selected, add with quantity 1
      return {
        ...prev,
        [key]: {
          group,
          product,
          quantity: 1
        }
      };
    });
  };
  
  // Handle adding selected hardware to the door
  const handleAddHardware = async () => {
    // Process selected hardware items
    const hardwareItems = Object.values(selectedHardware).map(item => ({
      item_id: item.product._id,
      item_name: item.product.product_name,
      item_image: item.product.product_image,
      item_group_id: item.group.product_group_id,
      item_group_name: item.group.product_group_name,
      quantity: item.quantity,
      selling_price: item.product.selling_price,
      cost_price: item.product.cost_price,
      tax_rate: item.product.tax_rate,
      total_tax: item.product.total_tax,
      UOM: item.product.UOM_id,
      product_addon_type: 'hardware'
    }));
    
    setApplyingHardware(true);
    const success = await HandleSaveHardwareToItem(hardwareItems);
    
    if (success) {
      setHardwareAdded(true);
      // We don't clear the hardware state immediately to show what was added
      setTimeout(() => {
        // After showing success state for a moment, we can close the popup
        // setShowHardwarePopup(false);
        // setHardware([]);
      }, 3000);
    } else {
      setApplyingHardware(false);
    }
  };
  
  // Function to close the hardware popup and reset states
  const closeHardwarePopup = () => {
    setShowHardwarePopup(false);
    setSelectedHardware({});
    setHardwareAdded(false);
    setApplyingHardware(false);
    setHardware([]);
  };
  
  return (
 <>
  {/* Overlay */}
  <div
    className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
    onClick={closeHardwarePopup}
  ></div>
  
  {/* Popup - positioned at bottom with slide-up animation */}
  <div className="fixed inset-x-0 bottom-0 bg-white rounded-t-2xl shadow-2xl z-50 max-h-[95vh] overflow-y-auto transform transition-transform duration-300 ease-out">
    {/* Header with close button */}
    <div className="sticky top-0 bg-white px-4 py-4 border-b border-gray-100 z-10 rounded-t-2xl">
      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <h2 className="text-xl font-bold text-gray-900">Door Hardware</h2>
          <p className="text-sm text-gray-600 mt-1">
            Select hardware items for {selectedItem?.application_areas?.area_name || 'this door'}
          </p>
        </div>
        <button
          onClick={closeHardwarePopup}
          className="text-gray-400 hover:text-gray-600 p-2 rounded-full hover:bg-gray-100 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
    
    {/* Hardware selection content - Only show if not in applied or applying state */}
   {!applyingHardware && !hardwareAdded && (
  <>
    {/* Selected items summary - sticky */}
    {Object.keys(selectedHardware).length > 0 && (
      <div className="sticky top-[89px] z-10 px-4 py-2 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-medium text-gray-900 text-sm">Selected Items</h4>
          <span className="bg-[#F30F0F] text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
            {Object.keys(selectedHardware).length}
          </span>
        </div>
        <div
          id="selected-hardware-container"
          className="flex overflow-x-auto space-x-2 pb-2 scroll-smooth"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {Object.values(selectedHardware).map((item, index) => {
            const isLastItem = index === Object.values(selectedHardware).length - 1;
            return (
              <div
                key={`${item.group.product_group_id}-${item.product._id}`}
                id={`selected-item-${item.group.product_group_id}-${item.product._id}`}
                className={`flex-shrink-0 bg-gray-50 rounded-lg border p-1.5 w-20 shadow-sm ${
                  isLastItem ? 'border-[#F30F0F] animate-pulse' : 'border-gray-300'
                }`}
                ref={isLastItem ? (el) => {
                  if (el) {
                    setTimeout(() => {
                      el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
                    }, 100);
                  }
                } : null}
              >
                <div className={`h-10 w-full bg-white rounded-md mb-1 flex items-center justify-center ${
                  isLastItem ? 'ring-1 ring-[#F30F0F] ring-opacity-30' : ''
                }`}>
                  <img
                    src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.product.product_image}
                    alt={item.product.product_name}
                    className="h-8 w-8 object-contain"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/32?text=No+Image";
                    }}
                  />
                </div>
                <div className="text-center">
                  <p
                    className="text-[9px] font-medium text-gray-800 mb-1 leading-tight h-4 overflow-hidden"
                    title={item.product.product_name}
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      wordBreak: 'break-word'
                    }}
                  >
                    {item.product.product_name}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-[8px] text-gray-600 font-medium">Qty: {item.quantity}</span>
                    <button
                      className="text-red-500 hover:text-red-700 hover:bg-red-100 p-0.5 rounded-full transition-colors"
                      onClick={() => {
                        setSelectedHardware(prev => {
                          const newSelected = { ...prev };
                          delete newSelected[`${item.group.product_group_id}-${item.product._id}`];
                          return newSelected;
                        });
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )}
    
    {/* Hardware groups */}
    <div className="p-2 bg-gray-50">
      {hardware && hardware.length > 0 ? (
        <div className="space-y-3">
          {hardware.map((group, groupIndex) => (
            <div key={groupIndex} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
              {/* Group header */}
              <div className="bg-gradient-to-r from-gray-100 to-gray-50 px-3 py-2 border-b border-gray-200">
                <div className="flex items-center">
                  <div className="w-1.5 h-1.5 bg-[#F30F0F] rounded-full mr-2"></div>
                  <h4 className="font-medium text-gray-900 text-xs">{group.product_group_name}</h4>
                  <span className="ml-auto text-[10px] text-gray-500 bg-gray-200 px-1.5 py-0.5 rounded-full">
                    {group.products.length} items
                  </span>
                </div>
              </div>
              
              {/* Group products - horizontal scrolling */}
              <div className="p-2">
                <div className="overflow-x-auto" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                  <div className="flex space-x-2 pb-1">
                    {group.products.map((product, productIndex) => (
                      <div
                        key={productIndex}
                        className={`w-[90px] border-2 rounded-lg overflow-hidden flex-shrink-0 transition-all duration-200 ${
                          selectedHardware[`${group.product_group_id}-${product._id}`]
                            ? 'border-[#F30F0F] shadow-md bg-gray-50'
                            : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                        }`}
                      >
                        {/* Product image */}
                        <div
                          className={`h-14 flex items-center justify-center p-1 border-b border-gray-100 cursor-pointer transition-colors ${
                            selectedHardware[`${group.product_group_id}-${product._id}`]
                              ? 'bg-gray-50'
                              : 'bg-gradient-to-br from-gray-50 to-white hover:bg-gray-100'
                          }`}
                          onClick={() => handleSelectHardware(group, product)}
                        >
                          <img
                            src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + product.product_image}
                            alt={product.product_name}
                            className="max-h-12 max-w-full object-contain"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "https://via.placeholder.com/80?text=No+Image";
                            }}
                          />
                        </div>
                        
                        {/* Product info */}
                        <div className="p-1.5">
                          <h5
                            className="text-[10px] font-medium text-gray-800 mb-1 leading-tight h-6 overflow-hidden"
                            title={product.product_name}
                            style={{
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              wordBreak: 'break-word'
                            }}
                          >
                            {product.product_name}
                          </h5>
                          <p className="text-[9px] text-gray-600 mb-1.5 font-semibold">
                            ₹{parseInt(product.selling_price).toLocaleString()}
                          </p>
                          
                          {/* Quantity controls or Add button */}
                          {selectedHardware[`${group.product_group_id}-${product._id}`] ? (
                            <div className="flex items-center justify-between border border-[#F30F0F] rounded-md overflow-hidden bg-white">
                              <button
                                className="w-5 h-5 flex items-center justify-center text-[#F30F0F] hover:bg-red-50 transition-colors"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const currentQty = selectedHardware[`${group.product_group_id}-${product._id}`].quantity;
                                  handleQuantityChange(group.product_group_id, product._id, currentQty - 1);
                                }}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-2.5 w-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                                </svg>
                              </button>
                              <span className="flex-1 text-[10px] font-bold text-center bg-red-50 text-[#F30F0F] py-0.5">
                                {selectedHardware[`${group.product_group_id}-${product._id}`].quantity}
                              </span>
                              <button
                                className="w-5 h-5 flex items-center justify-center text-[#F30F0F] hover:bg-red-50 transition-colors"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const currentQty = selectedHardware[`${group.product_group_id}-${product._id}`].quantity;
                                  handleQuantityChange(group.product_group_id, product._id, currentQty + 1);
                                }}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-2.5 w-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                              </button>
                            </div>
                          ) : (
                            <button
                              className="w-full text-center border border-[#F30F0F] bg-white text-[#F30F0F] hover:bg-[#F30F0F] hover:text-white font-medium py-1 px-1 rounded-md text-[9px] flex items-center justify-center transition-all duration-200"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelectHardware(group, product);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-2.5 w-2.5 mr-0.5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 4v16m8-8H4"
                                />
                              </svg>
                              Add
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* View all button if more than 3 products */}
                {group.products.length > 3 && (
                  <button
                    className="text-[#3C5DB1] text-[10px] font-semibold mt-2 flex items-center hover:text-[#2A4A9A] transition-colors"
                    onClick={() => {
                      // Implement view all functionality
                    }}
                  >
                    View all {group.products.length} items
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-2.5 w-2.5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center h-32 bg-white rounded-lg border border-gray-200">
          <div className="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <p className="text-gray-500 text-xs font-medium">No hardware items available</p>
            <p className="text-gray-400 text-[10px] mt-1">Check back later for more options</p>
          </div>
        </div>
      )}
    </div>
  </>
)}

    
    {/* Loading state */}
    {applyingHardware && (
      <div className="p-8 flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-white">
        <div className="relative">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-[#F30F0F] mb-6"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 bg-[#F30F0F] rounded-full opacity-20 animate-pulse"></div>
          </div>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">Adding Hardware</h3>
        <p className="text-sm text-gray-600 text-center max-w-xs">
          Please wait while we add the selected hardware items to your door configuration.
        </p>
        <div className="mt-4 flex space-x-1">
          <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-[#F30F0F] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    )}
    
   {/* Success state */}
{hardwareAdded && (
  <div className="p-6 flex flex-col items-center justify-center bg-gradient-to-br from-red-50 to-pink-50">
    <div className="relative mb-4">
      <div className="bg-gradient-to-r from-[#F30F0F] to-[#C20C0C] rounded-full h-16 w-16 flex items-center justify-center shadow-md">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div className="absolute -top-1 -right-1 w-5 h-5 bg-white rounded-full flex items-center justify-center shadow-sm border border-red-200">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-[#F30F0F]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
    
    <h3 className="text-lg font-bold text-gray-800 mb-2">Hardware Added!</h3>
    <p className="text-sm text-gray-600 text-center mb-4 max-w-xs">
      Selected hardware items have been added to your door.
    </p>
    
    {/* Show summary of added items */}
    <div className="w-full max-w-sm bg-white rounded-lg border border-red-100 p-3 mb-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-800">Added Items</h4>
        <span className="bg-red-100 text-[#C20C0C] text-xs font-medium px-2 py-0.5 rounded-full">
          {Object.keys(selectedHardware).length}
        </span>
      </div>
      <div className="space-y-2 max-h-44 overflow-y-auto">
        {Object.values(selectedHardware).map((item, index) => (
          <div key={index} className="flex items-center bg-gray-50 rounded-md p-2">
            <div className="h-8 w-8 bg-white rounded-md overflow-hidden mr-2 flex-shrink-0">
              <img
                src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.product.product_image}
                alt={item.product.product_name}
                className="h-full w-full object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/32?text=Item";
                }}
              />
            </div>
            <div className="flex-1 min-w-0">
              <p
                className="text-xs font-medium text-gray-800 truncate"
                title={item.product.product_name}
              >
                {item.product.product_name}
              </p>
              <div className="flex items-center justify-between mt-0.5">
                <span className="text-[10px] text-gray-500">
                  Qty: {item.quantity}
                </span>
                <span className="text-[10px] text-[#C20C0C] font-medium">
                  ₹{parseInt(item.product.selling_price * item.quantity).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

{/* Action buttons */}
<div className="sticky bottom-0 bg-white p-4 border-t border-gray-200 shadow-md">
  {!applyingHardware && !hardwareAdded ? (
    <div className="flex space-x-3">
      <button
        onClick={closeHardwarePopup}
        className="flex-1 border border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors"
      >
        Cancel
      </button>
      <button
        onClick={handleAddHardware}
        className={`flex-1 font-medium py-3 px-4 rounded-lg transition-all duration-200 ${
          Object.keys(selectedHardware).length === 0
            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
            : 'bg-gradient-to-r from-[#F30F0F] to-[#C20C0C] text-white hover:from-[#E00E0E] hover:to-[#B00B0B] shadow-lg'
        }`}
        disabled={Object.keys(selectedHardware).length === 0}
      >
        {Object.keys(selectedHardware).length === 0 
          ? 'Select Items' 
          : `Add Selected (${Object.keys(selectedHardware).length})`
        }
      </button>
    </div>
  ) : hardwareAdded ? (
    <button
      onClick={closeHardwarePopup}
      className="w-full bg-gradient-to-r from-[#F30F0F] to-[#C20C0C] text-white font-medium py-3 px-4 rounded-lg hover:from-[#E00E0E] hover:to-[#B00B0B] transition-all duration-200 shadow-lg"
    >
      Continue
    </button>
  ) : null}
</div>

  </div>
</>

);

        
};


  const hasSelectedDesigns = (item) => {
    if (!item || !item.applied_areas || !Array.isArray(item.applied_areas)) {
      return false;
    }
    
    return item.applied_areas.some(area => 
      area.selected_design && 
      (Array.isArray(area.selected_design) ? area.selected_design.length > 0 : Object.keys(area.selected_design).length > 0)
    );
  };
  
  // Function to get unique selected designs from applied areas
  const getUniqueSelectedDesigns = (item) => {
    if (!item || !item.applied_areas || !Array.isArray(item.applied_areas)) {
      return [];
    }
    
    const uniqueDesigns = new Map();
    
    item.applied_areas.forEach(area => {
      if (!area.selected_design) return;
      
      const designs = Array.isArray(area.selected_design) 
        ? area.selected_design 
        : [area.selected_design];
      
      designs.forEach(design => {
        if (design.design_id) {
          uniqueDesigns.set(design.design_id, {
            design_id: design.design_id,
            design_name: design.design_name,
            design_image: design.design_image,
            applied_areas: uniqueDesigns.has(design.design_id) 
              ? [...uniqueDesigns.get(design.design_id).applied_areas, area.area_name || area] 
              : [area.area_name || area]
          });
        }
      });
    });
    
    return Array.from(uniqueDesigns.values());
  };
  
const HandleMappingPriceSection = (item) => {
  // Calculate hardware total price
  const hardwareTotal = item.product_addons ? 
    item.product_addons
      .filter(addon => addon.product_addon_type?.toLowerCase() === 'hardware')
      .reduce((total, hardware) => {
        const itemPrice = parseFloat(hardware.selling_price) || 0;
        const quantity = parseInt(hardware.quantity) || 1;
        return total + (itemPrice * quantity);
      }, 0) : 
    0;
  
  // Calculate door price (without hardware)
  const doorPrice = (item.selling_price || 0) * (item.quantity || 0);
  
  // Calculate grand total including hardware
  const grandTotal = doorPrice + hardwareTotal;
  
  return (
    <>
      <div className="rounded-md bg-gray-100 p-2 mt-2">
        {/* Main price grid */}
        <div className="grid grid-cols-3 gap-1 mb-1">
          {/* Quantity Column - Left aligned */}
          <div>
            <p className="text-xs font-medium text-gray-500">Quantity</p>
            <div className="flex items-center">
              <p className="text-sm font-semibold">{item.quantity || 0}</p>
              <p className="text-gray-500 text-xs ml-1">{item.UOM || "pcs"}</p>
            </div>
          </div>
          
          {/* Unit Price Column - Center aligned */}
          <div className="text-center">
            <p className="text-xs font-medium text-gray-500">Unit Price</p>
            <div className="flex items-center justify-center">
              <p className="text-sm font-semibold">₹{formatCurrency(item.selling_price || 0)}</p>
              <p className="text-gray-500 text-xs ml-1">/{item.UOM || "pcs"}</p>
            </div>
          </div>
          
          {/* Door Price Column - Right aligned */}
          <div className="text-right">
            <p className="text-xs font-medium text-gray-500 mr-4">Door Price</p>
            <p className="text-sm font-semibold text-gray-800">
              ₹{formatCurrency(doorPrice)}
            </p>
          </div>
        </div>
        
        {/* Hardware price row - only shown if hardware exists */}
        {hardwareTotal > 0 && (
  <div className="flex justify-between mt-2 pt-2 border-t border-gray-200">
    <div /* className="col-span-2" */>
      <p className="text-xs font-medium text-gray-500">Hardware</p>
    </div>
    <div className="text-right">
      <p className="text-sm font-semibold text-gray-800 mr-1">
        <span className="text-gray-500 mr-0.5">+</span>₹{formatCurrency(hardwareTotal)}
      </p>
    </div>
  </div>
)}

        
        {/* Total price row */}
        <div className="grid grid-cols-3 gap-1 mt-2 pt-2 border-t border-gray-200">
          <div className="col-span-2">
            <p className="text-xs font-medium text-gray-600">Total Price</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-bold text-[#14A311] mr-1">
              ₹{formatCurrency(grandTotal)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};


 // New function to filter and map hardware from addons
const getHardwareFromAddons = (item) => {
  if (!item || !item.product_addons || !Array.isArray(item.product_addons)) {
    return [];
  }
  
  // Filter addons to only include hardware items
  return item.product_addons.filter(addon => 
    addon.product_addon_type === 'hardware'
  );
};

// Function to render hardware section based on filtered hardware addons
const renderHardwareSection = (item, index) => {
  const hardwareItems = getHardwareFromAddons(item);
  const hasHardware = hardwareItems.length > 0;
  
  if (hasHardware) {
    return (
      <div className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm">
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
        <div className="flex items-center">
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400 mr-1.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
  <h5 className="text-sm font-medium text-gray-800">Door Hardware</h5>
</div>


         
           <button
   onClick={() => handleOpenHardwarePopUp(item, index , hardwareItems)}
  className="rounded-md border-b border-dotted border-[#e8001c] px-2  flex flex-row items-center text-sm text-[#e8001c] font-medium hover:text-[#e8001c] "
>
 {/*  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
  </svg> */}
  <p >Change</p>
</button>
        </div>
        
        {/* Hardware showcase */}
        <div className="p-3">
          {/* Hardware count indicator */}
          <div className="mb-2 flex items-center">
            <div className="w-5 h-5 rounded-full bg-[#F0F7FF] flex items-center justify-center mr-1.5">
              <span className="text-[10px] font-medium text-[#3C5DB1]">{hardwareItems.length}</span>
            </div>
            <span className="text-xs text-gray-600">
              {hardwareItems.length === 1 ? 'Hardware item' : 'Hardware items'} selected for this door
            </span>
          </div>
          
          {/* Horizontal scrollable list of hardware items */}
          <div className="overflow-x-auto -mx-1 pb-1">
            <div className="flex space-x-3 px-1">
              {hardwareItems.map((hardware, idx) => (
                <div
                  key={idx}
                  className="flex-shrink-0 bg-gray-50 border border-gray-200 rounded-md p-1.5 w-20"
                >
                  {/* Hardware thumbnail */}
                  <div className="w-full h-16 bg-white rounded overflow-hidden mb-1.5 flex items-center justify-center">
                    <img
                      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + hardware.item_image}
                      alt={hardware.item_name}
                      className="max-h-full max-w-full object-contain p-0.5"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/80?text=Hardware";
                      }}
                    />
                  </div>
                  
                  {/* Hardware name */}
                  <div className="text-center">
                    <span className="text-[10px] font-medium text-gray-800 line-clamp-2 h-8" title={hardware.item_name}>
                      {hardware.item_name}
                    </span>
                    {hardware.quantity > 1 && (
                      <span className="text-[12px] text-gray-500 block">Qty:  <span className='font-bold'> {hardware.quantity}</span></span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (

    <button
  onClick={() => handleOpenHardwarePopUp(item, index, [])}
/*   className="w-full flex flex-row items-center justify-center gap-3 py-3 px-4 hover:bg-red-50 transition-colors border border-[#F30F0F] rounded-md" */
  className="w-full flex flex-row items-center justify-center gap-3 py-3 px-4 hover:bg-red-50 transition-colors border rounded-md"
  aria-label="Select door hardware"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-[#F30F0F]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
  <p className='text-[#F30F0F] text-sm font-medium'>
    Select Door Hardware
  </p>
</button>


    );
  }
};

// Updated handleMappigDesignsAndHardwareSections function
const handleMappigDesignsAndHardwareSections = (item, index) => {
  return (
    <>
      <div className="mt-2 space-y-3">
        {/* Door Design Section */}
        {hasSelectedDesigns(item) ? (
          // Show selected designs in detailed format
          <div className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm">
            {/* Header with design icon */}
            <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
              <div className="flex items-center">
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400 mr-1.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="2" width="18" height="20" rx="1" />
    <line x1="15" y1="8" x2="17" y2="8" />
    <line x1="7" y1="2" x2="7" y2="22" />
  </svg>
  <h5 className="text-sm font-medium text-gray-800">Door Design</h5>
</div>

             
              <button
     onClick={() => handleOpenDesignPopUp(item, index)}
  className="rounded-md border-b border-dotted border-[#e8001c] px-2  flex flex-row items-center text-sm text-[#e8001c] font-medium hover:text-[#e8001c] "
>
 {/*  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
  </svg> */}
  <p >Change</p>
</button>
            </div>
            
            {/* Design list - each design in its own row with improved image display */}
            <div className="px-2 py-1 space-y-3 max-h-72 overflow-y-auto">
              {getUniqueSelectedDesigns(item).map((design, designIndex) => (
                <div key={designIndex} className=" rounded-lg overflow-hidden bg-white  transition-shadow duration-200">
                  <div className="flex items-center px-2">
                    {/* Enhanced design image with better sizing and styling */}
                    <div className="w-32 h-36 bg-white rounded-md  overflow-hidden flex-shrink-0 mr-2 shadow-sm">
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-50 to-white p-1">
                        <img
                          src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + design.design_image}
                          alt={design.design_name}
                          className="max-h-full max-w-full object-contain"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/120?text=Door+Design";
                          }}
                        />
                      </div>
                    </div>
                    
                    {/* Design details with improved layout */}
                    <div className="flex-1 min-w-0">
                     <h5 
                      className="text-sm font-medium text-gray-800 mb-1.5 break-words line-clamp-2"
                      title={design.design_name}
                    >
                      {design.design_name}
                    </h5>

                      
                      {/* Selected indicator with checkmark */}
                      <div className="flex items-center mb-2">
                        <div className="flex items-center justify-center w-4 h-4 rounded-full bg-[#EBF3FF] mr-1.5">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-2.5 w-2.5 text-[#3C5DB1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <span className="text-xs text-[#3C5DB1] font-medium">Selected Design</span>
                      </div>
                      
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          // Just show the button if no designs selected
          <button
  onClick={() => handleOpenDesignPopUp(item, index)}
  /* className="w-full flex flex-row items-center justify-center gap-3 py-3 px-4 hover:bg-red-50 transition-colors border border-[#F30F0F] rounded-md" */
   className="w-full flex flex-row items-center justify-center gap-3 py-3 px-4 hover:bg-red-50 transition-colors border rounded-md"
  aria-label="Select door design"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-[#F30F0F]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="2" width="18" height="20" rx="1" />
    <path d="M6 2v20" />
    <path d="M15 12h2" />
    <path d="M10 7v2" />
    <path d="M10 15v2" />
  </svg>
  <p className='text-[#F30F0F] text-sm font-medium'>
    Select Door Design
  </p>
</button>


        )}
        
        {/* Door Hardware Section */}
        {renderHardwareSection(item, index)}
      </div>
    </>
  );
};

const handleCustomizeClick = () => {
 // console.log("Navigating to customize with type:", type); // Log before navigation
  navigate('/consumer/app/doorscustomize', { 
    state: { 
      data, 
      type: type
    } 
  });
};


  const renderFooterSection = ()=>{
   return (
    <> 
      <div className="border-t border-gray-300 fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 flex justify-between items-center z-10">
    <div className="flex flex-col">
      <p className="text-md font-semibold">Total Price</p>
      <div className="flex flex-col items-baseline">
        <span className="text-xl font-bold text-[#14A311]">₹{Number(data.subtotal).toLocaleString('en-IN')}</span>
        <span className="text-xs text-gray-500 ml-1">(+ GST & Transport)</span>
      </div>
    </div>
    <div className="flex flex-col">
      <button onClick={handleCustomizeClick} 
        className="border border-[#e8001c] text-[#e8001c] font-bold py-1 px-4 rounded mb-1">
        Customize
      </button>
      <button 
        onClick={() => navigate('/consumer/app/proceed', { state: { quotationId } })}
        className="flex flex-col bg-[#e8001c] text-white font-bold py-1 px-4 rounded">
        Proceed
      </button>
    </div>
  </div>

    </>
   )
  }

  // Function to format currency

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      
      {/* Back button and project info */}
         <ProjectHeader 
         projectName={data?.project_id?.projectName}
         type={'Quote Summary'}
         categoryName={data?.product_category_id?.product_category_name}
         Name={data?.customized_by ? data.quotation_number : (data?.package_name || data?.quotation_number)}
         Title={data?.customized_by ? 'My Saved Quote' : 'Quote by Brickbucket'}
         buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }  
         />

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"></div>
        </div>
      ) : (
        <div className="mb-24 px-4 mt-2">
          {data?.items?.map((item, index) => (
            <div
              key={index}
              className="border bg-white border-gray-300 rounded-lg overflow-hidden mb-3 shadow-sm"
            >
              <div className="p-3">
                {/* Header section with area name and measurements */}
                <div className="flex justify-between items-center mb-2">
                  <h5 className="text-red-500 text-lg font-bold truncate max-w-[200px]">
                    {item?.application_areas?.area_name || "Area"}
                  </h5>
                 <div className="flex flex-col items-end">
  {/* Area measurement with icon */}
  <div className="flex items-center mb-1">
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className="h-3 w-3 mr-1 text-gray-400" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="currentColor"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" 
      />
    </svg>
    <div className="text-gray-500 text-xs">
      <span className="font-bold">{item?.application_areas?.area || 0}</span>{" "}
      <span>sq.ft</span>
    </div>
  </div>
  
  {/* Door count with icon */}
  <div className="flex items-center">
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className="h-3 w-3 mr-1 text-gray-400" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="currentColor"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M12 3v18m0-18h7a2 2 0 012 2v14a2 2 0 01-2 2h-7m0-18H5a2 2 0 00-2 2v14a2 2 0 002 2h7" 
      />
    </svg>
      <div className="text-gray-500 text-xs">
    <span className=" font-bold">
      {item.application_areas?.count || 0} 
    </span> {" "}
    <span>{item.application_areas?.count === 1 ? 'Door' : 'Doors'}</span>
    </div>
  </div>
</div>

                </div>

                

               <div className="mb-3">
  {/* Main product with vendor */}
  <div className="flex items-center mb-2">
    {item.vendor?.image && (
      <img
        src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.vendor.image}
        alt={item.vendor?.name || "Vendor"}
        className="w-8 h-8 rounded-md mr-2 object-cover"
      />
    )}
    <h2
      className="text-gray-700 text-base font-semibold break-words max-w-[290px]"
      title={
        (!item.item_group_name || !item.item_name || item.item_group_name === item.item_name) ?
          (item.item_name || item.item_group_name || "Item Name") :
          `${item.item_group_name}`
      }
    >
      {(!item.item_group_name || !item.item_name || item.item_group_name === item.item_name) ?
        (item.item_name || item.item_group_name || "Item Name") :
        `${item.item_group_name}`}
    </h2>
  </div>
  
{/* Addons section - only show if addons exist */}
{item?.product_addons && item.product_addons.filter(addon => addon.product_addon_type !== 'hardware').length > 0 && (
  <div className=" mt-1">
    <div className="flex items-center mb-1.5">
      <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mr-1.5"></div>
      <span className="text-xs text-gray-500 font-medium">Part of this door:</span>
    </div>
    
    {/* Compact row-wise layout with horizontal scrolling */}
    <div className="overflow-x-auto -mx-1 pb-1">
      <div className="flex px-1 space-x-2">
        {item.product_addons
          .filter(addon => addon.product_addon_type !== 'hardware')
          .map((addon, index) => {
            // Find the subcategory for this addon if needed
            const addonSubcategory = data?.subcategories?.find(
              s => s._id === addon.item_sub_category_id || s._id === addon.item_subcategory?._id
            );
            
            return (
              <div 
                key={index}
                onClick={() => handleAddonClick(addon, null, addonSubcategory, item)}
                className="flex-shrink-0 bg-gray-100 rounded-md px-2 py-1 flex items-center cursor-pointer hover:bg-gray-200 transition-colors"
              >
                {addon.item_image && (
                  <div className="w-4 h-4 rounded-full bg-white mr-1.5 overflow-hidden flex-shrink-0">
                    <img
                      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + addon.item_image}
                      alt={addon.item_name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/16";
                      }}
                    />
                  </div>
                )}
               <span 
  className="text-xs text-gray-600 break-words max-w-auto" 
  title={addon.item_name}
>
  {addon.item_name}
</span>

              </div>
            );
          })}
      </div>
    </div>
  </div>
)}
</div>

                {/* Addon Vendors Mapping Section */}
                {handleMapAddonVendors(item)}

                {/* Room names section */}
              
              
                {/* Pricing details section */}
                
                
                {handleMappigDesignsAndHardwareSections(item, index)}

                  {HandleMappingPriceSection(item)}
      
              </div>
            </div>
          ))}

          {data?.items?.length === 0 && (
            <div className="flex justify-center items-center h-40 bg-white rounded-lg border border-gray-300">
              <p className="text-gray-500">No items found in this quotation</p>
            </div>
          )}
        </div>
      )}

      {renderFooterSection()}

      {/* Fixed bottom bar */}
    
      {/* Render design selection popup */}
      {renderDesignSelectionPopup()}

      {/* Render hardware selection popup */}
      {renderHardwareSelectionPopup()}

      {renderAddonDetailsPopup()}

    </div>
  );
}

export default DoorsStandardQuoteDetails;
